// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-item-card {
  display: flex;
  margin: 2rem;
  padding: 1.5rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #e5e7ebe2;
}

.vendor-item-image {
  /* background-color: blue; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  height: 50%;
  margin-bottom: 1rem;
}

img {
  border-radius: 15px;
  width: 80%;
  /* max-width: 5%; */
  max-height: 12rem;
  object-fit: cover;
  margin-right: 1rem;
}

.vendor-item-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 90%;
}

.item-input {
  width: 100%;
  padding: 5px;
  margin: 5px 0;
  border: none;
}

.item-btns {
  margin-top: 10px;
}

.save-changes,
.edit-changes {
  padding: 8px 15px;
  cursor: pointer;
  background-color: #274e13;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}

.save-changes:hover,
.edit-changes:hover,
.delete-item-btn:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

.delete-item-btn {
  padding: 4px 8px;
  cursor: pointer;
  background-color: #274e13;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}

.item-btns {
  display: flex;
  gap: 1rem;
  align-items: center;
}

@media (max-width: 1077px) {
  .vendor-item-details {
    flex-wrap: wrap;
  }
}
@media (max-width: 711px) {
  .vendor-item-details {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.vendor-view-card-details {
  max-height: 5rem;
  overflow: auto;
}

.vendor-view-card-details::-webkit-scrollbar {
  width: 12px;
}

.vendor-view-card-details::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;
}

.vendor-view-card-details::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./src/components/VendorItemCard/VendorItemCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".vendor-item-card {\n  display: flex;\n  margin: 2rem;\n  padding: 1.5rem;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  background-color: #e5e7ebe2;\n}\n\n.vendor-item-image {\n  /* background-color: blue; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 10%;\n  height: 50%;\n  margin-bottom: 1rem;\n}\n\nimg {\n  border-radius: 15px;\n  width: 80%;\n  /* max-width: 5%; */\n  max-height: 12rem;\n  object-fit: cover;\n  margin-right: 1rem;\n}\n\n.vendor-item-details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 90%;\n}\n\n.item-input {\n  width: 100%;\n  padding: 5px;\n  margin: 5px 0;\n  border: none;\n}\n\n.item-btns {\n  margin-top: 10px;\n}\n\n.save-changes,\n.edit-changes {\n  padding: 8px 15px;\n  cursor: pointer;\n  background-color: #274e13;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.save-changes:hover,\n.edit-changes:hover,\n.delete-item-btn:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n.delete-item-btn {\n  padding: 4px 8px;\n  cursor: pointer;\n  background-color: #274e13;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.item-btns {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n@media (max-width: 1077px) {\n  .vendor-item-details {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 711px) {\n  .vendor-item-details {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n}\n\n.vendor-view-card-details {\n  max-height: 5rem;\n  overflow: auto;\n}\n\n.vendor-view-card-details::-webkit-scrollbar {\n  width: 12px;\n}\n\n.vendor-view-card-details::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 6px;\n}\n\n.vendor-view-card-details::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
